import { keyBy } from 'lodash';
import { useMemo } from 'react';
import { AccountId, PermissionId, ProjectId } from 'api/models';
import { ProjectChannel } from 'api/pushes';
import { useAccount } from 'hooks/use-account';
import { useUser } from 'hooks/use-user';
import { ManagerPropsWithLoadedRange } from '../../types';
// import { useProjectPhasesWSManager } from './project-detail-socket-manger';
import { useProjectMembersWSManager } from './project-members-socket-manager';
import { useProjectUpdateWsManager } from './project-update-manager';

interface Props extends ManagerPropsWithLoadedRange {
  projectIds: number[];
}
export const useProjectsWSManager = (props: Props): void => {
  const userInfo = useUser();
  const { accountId } = useAccount();
  const projectPermissionMap = useMemo(
    () => keyBy(userInfo.permissions.projects, 'projectId'),
    [userInfo.permissions.projects],
  );

  const projectChannels = useMemo(() => {
    const temp: ProjectChannel[] = [];

    props.projectIds.forEach((projectId) => {
      if (projectPermissionMap[projectId]?.permissionSet?.permissionSetId) {
        temp.push(
          ProjectChannel(
            AccountId(accountId),
            PermissionId(
              projectPermissionMap[projectId].permissionSet.permissionSetId,
            ),
            ProjectId(projectId),
          ),
        );
      }
    });

    return temp;
  }, [accountId, projectPermissionMap, props.projectIds]);

  const params = useMemo(
    () => ({
      ...props,
      projectChannels,
    }),
    [projectChannels, props],
  );

  useProjectMembersWSManager(params);
  // useProjectPhasesWSManager(params);
  useProjectUpdateWsManager(params);
};
